import script from "./DocumentedHours.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentedHours.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentedHours.vue?vue&type=style&index=0&id=cea6f2e6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cea6f2e6"]])

export default __exports__